import { lazy, Suspense } from 'react';
import { useAuth } from '@/shared/contexts/AuthContext';

const BrokerCommissionsPage = lazy(() => import('../modules/broker/pages/BrokerCommissionsPage'));
const AdvisorCommissionsPage = lazy(() => import('../modules/commissions/pages/AdvisorCommissionsPage'));

/**
 * Renders the appropriate commissions page based on user role.
 * Brokers see BrokerCommissionsPage, advisors see AdvisorCommissionsPage.
 */
export default function CommissionsSwitch() {
  const { user } = useAuth();
  const isBroker = user?.role === 'owly_broker';

  return (
    <Suspense fallback={null}>
      {isBroker ? <BrokerCommissionsPage /> : <AdvisorCommissionsPage />}
    </Suspense>
  );
}
